import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = number;

export const useDefaultObservableNumber = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectNumber extends BehaviorSubject<CurrentType> {}
